import React, {

  useEffect,

  useState,
} from "react";
import "../../assets/css/responsive.css";
import "../../assets/css/style.css";
import { useMemo } from "react";


import { PaginationControls } from "../../models/pagination";

import Pagination from "../../components/pagination/pagination";
import { ApiUrl } from "../../config/apiConfig";
import { getData, postData } from "../../services/Axios/Axios";
import moment from "moment";
import messageService from "../../services/message/messageService";
import Search from "../../components/serchcomponet/search";

import { Bell, ChevronsUpDown } from "lucide-react";
import DeleteButton from "../../components/UIElements/DeleteButton";

import { sendAccountStatusChangeMail } from "../../functions/accountFunctions";
import UserData from "../companyScreen/UserData";
import { confirmAction, getCurrentUser, getRemainingTrialDays, getSourceColor } from "../../utils/utils";
import { useOutletContext } from "react-router-dom";
import Customer from "../../components/Customer";
import RightSidebar from "../../components/Sidebar/RightSidebar";
import BlockUnblockButton from "../../components/UIElements/BlockUnblockButton";
import { getAllReadEntryIds, isItemRead, markItemAsRead } from "../../functions/readEntriesTrack";
import { AdminUser } from "../../models/AdminUser";
import MainSlidingTabs from "../../components/UIElement/MainSlidingTabs";
import ViewIcon from "../../components/UIElement/ViewIcon";

const getCompanyValue = (company_type: string | null) => {
  if (!company_type) return "--";

  switch (company_type) {
    case "BROKER&CARRIER":
      return "BROKER & CARRIER";

    default:
      return company_type;
  }
};
type LayoutContext = {
  isExpanded: boolean;
};

export default function TrailUserPage() {

  const { isExpanded } = useOutletContext<LayoutContext>();
 
  const [allData, setAllData] = useState([]);
  const [pagination, setPagination] = useState(new PaginationControls());
  const [startIndex, setStartIndex] = useState(0);
  const [searchdata, setSearch] = useState("");
  const [chekingStatus, setchekingStatus] = useState<any>({});
  const [filter, setFilter] = useState<any>({});


  const [open, setOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<any>({});
  const [selectedTab, setSelectedTab] = useState<number>(1);
  const [trailCount, setTrailCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const currentUser = useMemo<AdminUser>(() => getCurrentUser(), []);



  const fetchData = async () => {
    setLoading(true);
    await getDataALL();
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [pagination.page, filter]);

  const getDataALL = async (searchdata?: any) => {
    const skip = (pagination.page - 1) * pagination.limit;
    const obj: any = {};
    if (searchdata) {
      obj.search = searchdata;
    }
    if (filter.company_type) {
      obj.company_type = filter.company_type;
    }
    const needPagination = !filter.company_type && !searchdata;
    if (needPagination) {
      obj.skip_number = skip;
    }

    try {
      const response = await getData(ApiUrl.listCompanies, obj);
      setAllData(response.data);
      const res = response.data.filter(
        (user: any) =>
          user.confirm_account === "PENDING" && user.isDeleted === false
      );
      setTrailCount(res.length);

      setPagination((prevPagination) => ({
        ...prevPagination,
        count: response.total_count,
      }));
      setStartIndex(
        (pagination.page === 0 ? 0 : (pagination.page - 1) * pagination.limit) +
        1
      );

      if (searchdata && response.data.length > 0) {
        // if search then switch to tab
        const userObj = response.data[0];

        setSelectedTab(getTabNumByUser(userObj));
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };


  const locallyFilteredData = React.useMemo(() => {
    if (!searchdata.trim()) return allData;

    const keyword = searchdata.toLowerCase();

    return allData.filter((user: any) => {
      return (
        `${user.first_name ?? ""} ${user.last_name ?? ""}`
          .toLowerCase()
          .includes(keyword) ||
        user.email?.toLowerCase().includes(keyword) ||
        user.name?.toLowerCase().includes(keyword) ||
        user.phone_number?.includes(keyword)
      );
    });
  }, [searchdata, allData]);


  const handlePageChange = (selectedPage: { selected: number }) => {
    const newPage = selectedPage.selected + 1;
    setPagination((prevPagination) => ({
      ...prevPagination,
      page: newPage,
    }));
  };

  const aproveCompany = async (data: any, selectedValue: any) => {
    let obj = {
      _id: data._id,
      confirm_account: selectedValue,
    };

    try {
      const response = await postData(ApiUrl.managedCompanies, obj);

      // send account mail
      sendAccountStatusChangeMail(
        data.email,
        data?.first_name ?? "User",
        response.confirm_account
      );

      console.log("Data posted successfully:", response);
      const messageServices = messageService();
      let chekingStatusall = response;
      setchekingStatus(chekingStatusall);
      if (response.confirm_account === "CONFIRMED") {
        messageServices.toast("success", messageServices.message.Account);
      } else if (response.confirm_account === "DENIED") {
        messageServices.toast("success", messageServices.message.reject);
      } else if (response.confirm_account === "PENDING") {
        messageServices.toast("success", messageServices.message.Confirmed);
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const formatDate = (
    dateString: moment.MomentInput,
    dateFormat = "MMMM DD, YYYY, HH:mm"
  ) => {
    if (!dateString) return "";
    return moment(dateString).format(dateFormat);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [singleUser, setsingleUser] = useState("");

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const filterUserByType = (users: any[], type: string) => {
    if (!users) return users;

    if (type === "blocked") {
      return users.filter((user) => user.isDeleted === true);
    }

    if (type === "NewEntry") {
      return users.filter(
        (user) => user.confirm_account === "PENDING" && user.isDeleted === false
      );
    }

    if (type === "trailUser") {
      return users.filter(
        (user) =>
          user.userType === type &&
          user.isDeleted === false &&
          user.confirm_account !== "PENDING"
      );
    }



    return users.filter(
      (user) => user.userType === type && user.isDeleted === false
    );
  };

  const handleSearchChange = (value: string) => {
    setSearch(value);
  };

  const handleSearchSubmit = () => {
    getDataALL(searchdata);
  };

  let deleteData = async (data: any) => {
    const messageServices = messageService();

    messageServices.confirm(`block this User`, "").then(async (res) => {
      if (res.value) {
        const obj = {
          _id: data._id,
          isDeleted: !data.isDeleted,
        };
        let response = postData(ApiUrl.deletecomapnyAndItsUsers, obj);
        if (await response) {
          getDataALL();
          messageServices.toast(
            "success",
            messageServices.message.deleteSuccess
          );
        }
      }
    });
  };

  let deletePermanentUser = async (data: any) => {
    const messageServices = messageService();
    const obj = {
      _id: data._id,
      isDeleted: !data.isDeleted,
    };

    let response = postData(ApiUrl.permanentDeleteCompanyAndItsUsers, obj);
    if (await response) {
      getDataALL();
      messageServices.toast(
        "success",
        messageServices.message.deleteSuccess
      );
    }

  };

  let restoreCompany = async (data: any) => {
    const messageServices = messageService();

    messageServices.confirm(`unblock this User`, "").then(async (res) => {
      if (res.value) {
        const obj = {
          _id: data._id,
          isDeleted: !data.isDeleted,
        };
        let response = postData(ApiUrl.restoreCompany, obj);
        if (await response) {
          getDataALL();
          messageServices.toast(
            "success",
            messageServices.message.deleteSuccess
          );
        }
      }
    });
  };

  const getUserTypeByNum = (tabNum: number) => {
    switch (tabNum) {
      case 1:
        return "NewEntry";
      case 2:
        return "trailUser";
      case 3:
        return "student";
      case 4:
        return "b2b";
      case 5:
        return "blocked";
      case 6:
        return "IFTA";
      default:
        return "NewEntry";
    }
  };

  const getTabNumByUser = (userObj: any): number => {
    if (userObj.confirm_account === "PENDING") {
      return 1;
    } else if (userObj.isDeleted) {
      return 5;
    }

    switch (userObj.userType) {
      case "trailUser":
        return 2;
      case "student":
        return 3;
      case "b2b":
        return 4;
      default:
        return 1;
    }
  };

  const onBlockUnBlockToggle = (user: any) => {
    if (!user.isDeleted) {
      deleteData(user);
    } else {
      restoreCompany(user);
    }
  };


  const updatePermissions = async (data: any, permissions: string[]) => {
    let obj = {
      _id: data._id,
      permissions: permissions,
    };

    try {
      await postData(ApiUrl.managedCompanies, obj);

      const messageServices = messageService();

      getDataALL();

      messageServices.toast("success", "User Permissions Updated!");
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };



  return (
    <>
      <div className="flex text-textColor  bg-customGray font-sans relative h-full ">
        <div className='flex flex-col flex-1 sm:w-4/5 p-0"'>
          <div className=" bg-gray-100 p-0">
            <div
              className={`flex items-center h-[49px] justify-between
  bg-white/40 backdrop-blur-md border border-white/30 shadow-lg
  fixed top-0 z-[9] transition-all duration-200 ease-in px-4
 ${isExpanded ? 'left-[230px] w-[calc(100%-228px)]' : 'left-[73px] w-[calc(100%-70px)]'}`}
            >
              {/* Left: icon and Breadcrumbs */}
              <div className="flex items-center ">
                <div className="flex items-center space-x-2">
                  <svg
    viewBox="0 0 495 495"
    className="h-6 w-6"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#0070706E76E5"
      d="M89.803,366.872V257.069c-30.272,0-54.901,24.629-54.901,54.902S59.53,366.872,89.803,366.872z"
    />
    <path
      fill="#0070706E76E5"
      d="M89.803,385.041C40.285,385.041,0,425.327,0,474.844v20h179.605v-20C179.605,425.327,139.32,385.041,89.803,385.041z"
    />
    <path
      fill="#0070706E76E5"
      d="M405.197,366.872V257.069c-30.272,0-54.901,24.629-54.901,54.902S374.925,366.872,405.197,366.872z"
    />
    <path
      fill="#0070706E76E5"
      d="M405.197,385.041c-49.518,0-89.803,40.286-89.803,89.803v20H495v-20C495,425.327,454.715,385.041,405.197,385.041z"
    />
    <path
      fill="#0070706E76E5"
      d="M247.5,109.959V0.156c-30.272,0-54.901,24.629-54.901,54.902S217.228,109.959,247.5,109.959z"
    />
    <path
      fill="#007070"
      d="M144.704,311.971c0-30.273-24.629-54.902-54.901-54.902v109.803C120.075,366.872,144.704,342.243,144.704,311.971z"
    />
    <path
      fill="#007070"
      d="M460.099,311.971c0-30.273-24.629-54.902-54.901-54.902v109.803C435.47,366.872,460.099,342.243,460.099,311.971z"
    />
    <path
      fill="#007070"
      d="M302.401,55.057c0-30.273-24.629-54.902-54.901-54.902v109.803C277.772,109.959,302.401,85.33,302.401,55.057z"
    />
    <path
      fill="#0070706E76E5"
      d="M337.303,217.931c0-49.518-40.285-89.803-89.803-89.803s-89.803,40.286-89.803,89.803v20h179.605v-20z"
    />
    <polygon
      fill="#00707000EED1"
      points="267.5,333.052 267.5,267.816 227.5,267.816 227.5,333.052 171.004,365.67 191.004,400.311 247.5,367.693 303.996,400.311 323.996,365.67"
    />
  </svg>
                  <span className="font-bold text-lg">TMS Users</span>
                </div>
              </div>

              {/* Right: Search & Button */}
             
<div className="relative flex items-center
 gap-2">
                <div className="gap-2 flex text-[13px] font-normal sm:max-w-[300px]  md:max-w-[400px]
  lg:max-w-[750px]
  xl:max-w-[940px]
  2xl:max-w-[1300px]
  3xl:max-w-[1400px]
  4xl:max-w-[1500px]
  5xl:max-w-[1700px]
  6xl:max-w-[1900px]
  
  overflow-x-auto
  whitespace-nowrap
  
  no-scrollbar   pr-[35px] ">
                    <button className=" bg-[#DBEBEB] text-greenBg border border-greenBg hover:bg-[linear-gradient(15deg,#007070,#007070,#038383,#04bebe,#04bebe,#05d4d4,#038383,#007070,#007070)]
  bg-[length:300%]
  bg-left

  shadow-[0_30px_10px_-20px_rgba(0,0,0,0.2)] 
  transition-[background] duration-300 ease-in-out py-[2px] px-[6px] hover:text-white rounded-full">
                    All 99
                  </button>
                  <button className="border  border-[#0584C0] text-[#0584C0] bg-[#DCEEF6] hover:bg-gradient-to-r from-[#023E5A] to-[#0584C0] hover:text-white transition-colors duration-300 py-[6px] px-1  rounded-full text-[12px]  font-normal">
                    New Student 09
                  </button>
                  <button className="border border-[#3353BB] text-[#3353BB] bg-[#E2E7F5] hover:bg-gradient-to-r from-[#172655] to-[#3353BB] hover:text-white transition-colors duration-300  py-[6px] px-1  rounded-full text-[12px] font-normal">
                    Intro Done 12
                  </button>
                  <button className="border border-[#FFC008] text-[#FFC008] bg-[#FFF6DC] hover:bg-gradient-to-r from-[#997305] to-[#FFC008] hover:text-white transition-colors duration-300  py-[6px] px-1  rounded-full text-[12px] font-normal">
                    In Progress 99
                  </button>
                  <button className="border border-[#F14444] text-[#F14444] bg-[#FDE5E5] hover:bg-gradient-to-r from-[#8B2727] to-[#F14444] hover:text-white transition-colors duration-300  py-[6px] px-1  rounded-full text-[12px] font-normal">
                    Non Response 9
                  </button>
                  <button className="border border-[#02B140] text-[#02B140] bg-[#DCF4E4] hover:bg-gradient-to-r from-[#09524A] to-[#14B8A6] hover:text-white transition-colors duration-300  py-[6px] px-1  rounded-full text-[12px] font-normal">
                    Training Done 72
                  </button>
                  <button className="border border-[#39B7FF] text-[#39B7FF] bg-[#DCEEF6] hover:bg-gradient-to-r from-[#226E99] to-[#39B7FF] hover:text-white transition-colors duration-300  py-[6px] px-1  rounded-full text-[12px] font-normal ml-1">
                    Review Pending 72
                  </button>
                  <button className="border border-[#02B140] text-[#02B140] bg-[#DCF4E4] hover:bg-gradient-to-r from-[#014B1B] to-[#02B140] hover:text-white transition-colors duration-300  py-[6px] px-1  rounded-full text-[12px] font-normal">
                    Closed 99
                  </button>
                </div>
                <div className="absolute right-0 top-1/2 -translate-y-1/2 z-10">
                <Search
                  search={searchdata}
                  onSearchChange={function (value: string): void {
                    handleSearchChange(value);
                  }}
                  onClick={function (): void {
                    handleSearchSubmit();
                  }}
                /></div>
                {/* <Dropdown
                  options={companyFilterOptions}
                  onChange={(value) => {
                    handleFilterChange(value);
                  }}
                ></Dropdown> */}
              </div>
            </div>
            <div className="sticky pt-[58px]  !z-[1]">
              <div className="bg-[#ffffff] mx-[10px] shadow-[0_0_10px_0_#00000021] relative overflow-hidden rounded-t-[14px] ">
                {/* Top Button Bar */}
                <div className="flex items-center justify-between px-2 py-2">
                  <div className="flex items-center gap-2">
                    <MainSlidingTabs
                      tabs={[
                        { id: 1, label: "New Entry" },
                        { id: 2, label: "Trial User" },
                        { id: 3, label: "Student" },
                        { id: 4, label: "B2B" },
                        { id: 5, label: "Rejected" },
                      ]}
                      selectedTab={selectedTab}
                      onTabChange={(id) => {
                        setSelectedTab(id);
                        if (open) {
                          setOpen(false)
                        }

                      }}

                    />
                  </div>

                  {selectedTab === 1 && (
                    <button className="bg-gray-100 hover:bg-gray-200 px-1 py-1  rounded-full items-center relative">
                      <span className="absolute  bg-customOrange !top-[-10px] !left-[-6px] !text-white !text-[12px] w-[19px] h-[19px] rounded-full flex items-center justify-center">
                        {trailCount - getAllReadEntryIds().length}
                      </span>

                      <Bell size={20} />
                    </button>
                  )}
                </div>
                <div className="tablebox">
                  <div className="tablebox12">
                    <div className="scrollbar-box newclassscroll ">
                      {/* New */}
                      <div className="relative overflow-hidden h-full">
                        <div className="overflow-x-auto   h-full">
                          <table className="border-collapse  text-black w-full ">
                            <thead className="whitespace-nowrap bg-[#F6F6F7] border border-[#E2E2E2] ">
                              <tr className="text-[13px] font-medium  bg-customGray">
                                <th className="px-3 py-1 text-center border border-[#E2E2E2] font-medium  border-l-[#F6F6F7]">
                                  <div className="flex items-center gap-1">
                                    <span>S No  </span>
                                    <ChevronsUpDown size="12px" />
                                  </div>
                                </th>

                                {/* {currentUser.tmsPermissions.includes("View") && */}
                                  <th className="px-2 py-1 border border-[#E2E2E2] font-medium ">
                                    View
                                  </th>
                                {/* } */}


                                <th className="  px-3 py-1 text-center border border-[#E2E2E2] font-medium ">
                                  <div className="flex items-center justify-between">
                                    <span>Full Name</span>
                                    <ChevronsUpDown size="12px" />
                                  </div>
                                </th>

                                <th className="px-3 py-1 text-center border border-[#E2E2E2] font-medium ">
                                  <div className="flex items-center justify-between">
                                    <span>Company Name</span>
                                    <ChevronsUpDown size="12px" />
                                  </div>
                                </th>
                                <th className="  px-3 py-1 text-center border border-[#E2E2E2] font-medium ">
                                  <div className="flex items-center justify-between">
                                    <span>Source</span>
                                    <ChevronsUpDown size="12px" />
                                  </div>
                                </th>

                                <th className="  px-3 py-1 text-center border border-[#E2E2E2] font-medium ">
                                  <div className="flex items-center justify-between">
                                    <span>Phone Number</span>
                                    <ChevronsUpDown size="12px" />
                                  </div>
                                </th>

                                <th className="  px-3 py-1 text-center border border-[#E2E2E2] font-medium ">
                                  <div className="flex items-center justify-between">
                                    <span>Type</span>
                                    <ChevronsUpDown size="12px" />
                                  </div>
                                </th>

                                {selectedTab === 2 && (
                                  <th className="  px-3 py-1 text-center border border-[#E2E2E2] font-medium ">
                                    <div className="flex items-center justify-between">
                                      <span>Expire in</span>
                                    </div>
                                  </th>
                                )}

                                <th className="px-3 py-1 text-center border border-[#E2E2E2] font-medium ">
                                  <div className="flex items-center justify-between">
                                    <span>Email ID</span>
                                    <ChevronsUpDown size="12px" />
                                  </div>
                                </th>

                                <th className=" px-3 py-1 text-center border border-[#E2E2E2] font-medium ">
                                  <div className="flex items-center justify-between">
                                    <span>Created At</span>
                                    <ChevronsUpDown size="12px" />
                                  </div>
                                </th>
                                {/* {currentUser.tmsPermissions.includes("Delete") && */}
                                  <th className=" px-3 py-1 text-center border border-[#E2E2E2] font-medium ">
                                    <div className="flex items-center justify-between">
                                      <span>
                                        {selectedTab === 5 ? "Action" : "Block"}
                                      </span>
                                    </div>
                                  </th>
                                {/* } */}
                              </tr>
                            </thead>
                            <tbody className="whitespace-nowrap border border-[#E2E2E2] ">
                              {loading ? (
                                <tr>
                                  <td colSpan={12} className="h-[200px]">
                                    <div className="flex items-center justify-center h-full w-full">
                                      <div className="flex flex-col items-center gap-3">
                                        <div className="w-10 h-10 border-4 border-gray-300 border-t-greenBg rounded-full animate-spin" />
                                        <p className="text-sm text-gray-500">
                                          Loading data...
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                filterUserByType(
                                  locallyFilteredData,
                                  getUserTypeByNum(selectedTab)
                                ).map((data: any, index) => (
                                  <tr
                                    key={index}
                                    className={`  text-[12px]   ${selectedCustomer?._id === data._id ? "bg-green-200 hover:bg-green-300" : data?.confirm_account === "PENDING" && !isItemRead(data._id) ? "bg-purple-200 hover:bg-purple-300" : "hover:bg-[#f0f0f0]"} `}
                                  >
                                    <td className="  px-3 py-1 border border-[#E2E2E2] border-r-gray-50 group-hover:border-r-[#f0f0f0] border-l-white hover:border-l-[#f0f0f0] text-[#667085]">
                                      {startIndex + index}
                                    </td>

                                    {/* {currentUser.tmsPermissions.includes("View") && */}
                                      <td
                                        className="px-3 py-1 border  border-[#E2E2E2] border-r-gray-50 group-hover:border-r-[#f0f0f0]   relative group cursor-pointer "
                                        onClick={() => {
                                          setSelectedCustomer(data);
                                          setOpen(true);
                                          if (data?.confirm_account === "PENDING") {
                                            markItemAsRead(data._id)
                                          }
                                        }}
                                      >
                                        <ViewIcon />

                                      </td>
                                      {/* } */}

                                    <td className=" px-3 py-1 border border-[#E2E2E2] border-r-gray-50 group-hover:border-r-[#f0f0f0] text-[#101828]">
                                      {`${data.first_name} ${data.last_name ? data.last_name : ""
                                        }`}
                                    </td>
                                    <td className="px-3 py-1 border border-[#E2E2E2] border-r-gray-50 group-hover:border-r-[#f0f0f0] text-[#667085] ">
                                      {data?.name ? data?.name : "--"}
                                    </td>
                                    <td className="px-3 py-1 border border-[#E2E2E2] border-r-gray-50 group-hover:border-r-[#f0f0f0] ">
                                      <div
                                        className={` ${getSourceColor(data?.source ?? "Main")}  flex items-center gap-[6px]
    border border-current
    text-xs font-medium
    px-2 py-1 rounded-full `}
                                      >
                                        <span className="inline-block w-[7px] h-[7px] rounded-full bg-current"></span>
                                         {data?.source ?? "Main"}
                                      </div>
                                    </td>
                                    <td className=" px-3 py-1 border border-[#E2E2E2] border-r-gray-50 group-hover:border-r-[#f0f0f0] text-[#667085]  ">
                                      {data?.phone_number
                                        ? `(${data?.phone_number.slice(
                                          0,
                                          3
                                        )}) ${data?.phone_number.slice(
                                          3,
                                          6
                                        )}-${data?.phone_number.slice(6, 10)}`
                                        : "--"}
                                    </td>

                                    <td className=" px-3 py-1 border border-[#E2E2E2] border-r-gray-50 group-hover:border-r-[#f0f0f0] text-[#667085]">
                                      {getCompanyValue(data?.company_type)}
                                    </td>

                                    {selectedTab === 2 && (
                                      <td
                                        className={` border border-[#E2E2E2] px-3 py-1  border-r-gray-50 group-hover:border-r-[#f0f0f0]`}
                                      >
                                        {data?.trialStartDate ? (
                                          <div
                                            className={` text-center rounded-full text-xs font-semibold  ${getRemainingTrialDays(
                                              data?.trialStartDate
                                            ) > 0
                                              ? "px-2 py-1 border border-green-500 rounded-full  bg-green-100 text-green-500"
                                              : " px-2 py-1 border border-red-500 rounded-full  bg-red-100 text-red-500"
                                              }`}
                                          >
                                            {getRemainingTrialDays(
                                              data?.trialStartDate
                                            ) > 0
                                              ? `${getRemainingTrialDays(
                                                data?.trialStartDate
                                              )} Days`
                                              : `Expired`}
                                          </div>
                                        ) : (
                                          <div className="px-3 py-1 ">N/A</div>
                                        )}
                                      </td>
                                    )}

                                    <td className=" px-3 py-1 border border-[#E2E2E2] border-r-gray-50 group-hover:border-r-[#f0f0f0] text-blue-600">
                                      {data.email ? data.email : "--"}
                                    </td>

                                    <td className=" px-3 py-1 border border-[#E2E2E2] border-r-gray-50 group-hover:border-r-[#f0f0f0] text-[#667085]">
                                      {data?.createdAt
                                        ? formatDate(data.createdAt)
                                        : "--"}
                                    </td>

                                    <td className=" text-center  items-center px-2 py-[2px] border border-[#E2E2E2]">
                                      <div className=" w-full flex justify-center gap-1 items-center relative ">

                                        {selectedTab !== 5 &&
                                          <BlockUnblockButton
                                            
                                            onClick={() =>
                                              onBlockUnBlockToggle(data)
                                            }
                                            isBlocked={data.isDeleted}
                                          ></BlockUnblockButton>
                                        }

                                        {(selectedTab === 5 ) && (
                                          <DeleteButton
                                            
                                            onClick={() => {
                                              confirmAction("delete this user", () => deletePermanentUser(data))
                                            }
                                            }
                                          ></DeleteButton>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>

                          {!loading &&
                            filterUserByType(
                              locallyFilteredData,
                              getUserTypeByNum(selectedTab)
                            ).length === 0 && (
                              <div className="text-center text-sm mt-12 capitalize">
                                No {getUserTypeByNum(selectedTab)} User Found
                              </div>
                            )}
                          {/* New Table */}
                        </div>
                        <RightSidebar
                          isOpen={open}
                          onClose={() => setOpen(false)}
                          width="w-[60%] sm:w-[90%] lg:w-[65%]"
                        >
                          {/* SideBar Content */}
                          {selectedCustomer &&
                          <Customer
                            activeButton={selectedTab}
                            onClose={() => setOpen(false)}
                            onCustomerUpdateSuccess={getDataALL}
                            setSelectedCustomer={setSelectedCustomer}
                            selectedCustomer={selectedCustomer}
                            setPermissions={(updated) => {
                              setSelectedCustomer((prev: any) => ({ ...prev, permissions: updated }));
                              updatePermissions(selectedCustomer, updated)
                            }}
                            hideStatusBtn={selectedTab === 5}
                          ></Customer>}
                        </RightSidebar>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          
              <Pagination
                pagination={pagination}
                onPageChange={handlePageChange}
              />
            
          </div>
        </div>

        <UserData
          isOpens={isModalOpen}
          closeModal={closeModal}
          singleUser={singleUser}
        />
      </div>
    </>
  );
}
